export default __webpack_public_path__ + "static/equilibre_icon_lock-e0a3b2d5b097bbba303df28baf9370eb.png";